import React, { useEffect, useState } from "react";
import { FaTelegramPlane } from "react-icons/fa";
const TelegramShare = () => {
  const [backTotop, setBackTotop] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setBackTotop(true);
      } else {
        setBackTotop(false);
      }
    });
  }, []);
  const scrollTop = () => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      {backTotop && (
        <div className="fixed bottom-10 right-5 z-100 items-center flex">
          <a
            class="group relative inline-block text-md font-medium text-white focus:outline-none focus:ring"
            href={`https://t.me/aderawaddisu`}
          >
            <span class="absolute inset-0 translate-y-1.5 bg-[#075eba] transition-transform rounded-md"></span>

            <span class="relative block bg-[#0d9488] px-8 py-3 flex capitalize font-serif rounded-md">
              <FaTelegramPlane className="text-white item-center w-5 h-5 mr-2" />{" "}
              Chat On Telegram
            </span>
          </a>
          <span class="absolute flex h-10 w-10 -top-4 -right-5">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0d74e0] opacity-75"></span>
            <span class="absolute rounded-full h-3 w-3 bg-[#075eba] top-[35%] left-[35%]"></span>
          </span>
        </div>
      )}
    </>
  );
};
export default TelegramShare;
